import React from "react";
import PropTypes from "prop-types";
import IconButton from "@/components/IconButton";
import { DeleteIcon, EditUserDataIcon } from "@/constant/imagePath";

function Actions({ row, handleOnClickDelete, handleOnClickEdit }) {
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      <IconButton
        icon={EditUserDataIcon}
        borderColor="#E80E57"
        fromColor="#FF6060"
        toColor="#EC1060"
        onClick={() => handleOnClickEdit(row.original)}
        tooltipText="Edit"
      />
      <IconButton
        icon={DeleteIcon}
        borderColor="#610002"
        fromColor="#AE1C28"
        toColor="#780002"
        onClick={() => handleOnClickDelete(row.original)}
        tooltipText="Delete"
      />
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickDelete: PropTypes.func.isRequired,
  handleOnChangeStatus: PropTypes.func.isRequired,
  handleOnClickEdit: PropTypes.func.isRequired,
};

export default React.memo(Actions);
